module.exports = __webpack_public_path__ + "static/media/msg-askcaution.95ced388.svg";